var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticStyle:{"line-height":"1.2"},attrs:{"variant":_vm.color_badge}},[_vm._v(_vm._s(_vm._f("dateBr")(_vm.date)))])
}
var staticRenderFns = []

export { render, staticRenderFns }